/* src/app/shared/components/address/address.component.css */
.address-bar {
  display: flex;
  flex-direction: column;
}
.manual-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
.manual-toggle input {
  height: 16px;
  margin-right: 12px;
  width: inherit;
}
.address-field-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.info-icon {
  margin-left: 8px;
  cursor: pointer;
  color: #1890ff;
}
/*# sourceMappingURL=address.component-LUFQ36YK.css.map */
